import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Inputs
import { DropDownField, TextInputField, CalendarField } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Menu } from 'primereact/menu';
import { utils, write } from "xlsx";
import Papa from "papaparse";

// redux
import { fetchStockSnapshot, updateSearchOptions, updateSearchParams, updateStockSnapshotData } from "../../../services/redux/reducers/stock/stockSnapshot";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

// api
import { searchStockWarehouse } from "../../../services/api/stockWarehouse";
import { searchStockDoc } from "../../../services/api/stockDoc";
import { getAddFilterOptions } from "../../../utils";

const stockMovesSeachConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Stock Doc', value: 'stockDoc' },
            { label: 'Stock Warehouse', value: 'stockWarehouse' }
        ]
    },
    {
        srNO: 2,
        static: true,
        type: "SEARCH_BY",
        name: "searchBy",
        label: "Search by",
        options: [
            { label: 'No Filters', value: 'all' },
            { label: 'Doc No', value: 'docNo' },
            { label: 'Material Id', value: 'materialId' },
            { label: 'Product Name', value: 'productName' },
            { label: 'Product Specification', value: 'productSpecification' }
        ]
    }
]

let customStockMovesSearchConfig = [
    {
        srNO: 3,
        static: false,
        type: "SELECT",
        name: "warehouseId",
        label: "Warehouse Name",
    },
]

const Search = (props) => {
    const dispatch = useDispatch()

    const { handleTableColumn } = props

    const isLoading = useSelector(state => state.companies.loading)

    const [searchConfig, setSearchConfig] = useState(stockMovesSeachConfig)

    const paginationParams = useSelector(state => state.stockSnapshot.paginationParams)
    const searchParams = useSelector(state => state.stockSnapshot.searchParams)
    const searchOptions = useSelector(state => state.stockSnapshot.searchOptions)

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)

    useEffect(() => {

        if (searchOptions.length === 0) {
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        if (searchParams) {
            if (searchParams?.dataType === "stockDoc") {
                if (searchOptions.length != 0) {
                    let relatedSearchOptions = searchOptions?.filter(eachOption => eachOption?.name !== "warehouseId")
                    let updatedSearchOptions = relatedSearchOptions?.map(eachOption => {
                        if (eachOption?.name === "searchBy") {
                            let relatedSearchByOptions = eachOption?.options?.find(eachOption => eachOption.value === "docNo")
                            let newOptions = []
                            if (!relatedSearchByOptions) {
                                newOptions.push({ label: 'Doc No', value: 'docNo' })
                            }

                            let updatedOptions = [...eachOption.options, ...newOptions]
                            return { ...eachOption, options: updatedOptions }
                        }
                        return eachOption
                    })
                    let relatedSearchConfig = searchConfig?.filter(eachOption => eachOption.name != "warehouseId")
                    if (relatedSearchConfig.length > 0) {
                        setSearchConfig([...relatedSearchConfig])
                    }
                    dispatch(updateSearchOptions(updatedSearchOptions))
                }
            } else {
                if (searchParams?.dataType === "stockWarehouse") {
                    if (searchOptions.length != 0) {
                        //let relatedSearchConfig = customStockMovesSearchConfig?.find(eachOption => eachOption.name === "warehouseId")
                        let updatedSearchOptions = searchOptions?.map(eachOption => {
                            if (eachOption?.name === "searchBy") {
                                let relatedSearchByOptions = eachOption?.options?.filter(eachOption => eachOption.value != "docNo")
                                let updatedOptions = [...relatedSearchByOptions]
                                return { ...eachOption, options: updatedOptions }
                            }
                            return eachOption
                        })

                        let relatedSearchConfig = searchConfig?.find(eachOption => eachOption.name === "warehouseId")
                        if (!relatedSearchConfig) {
                            let relatedCustomSearchConfig = customStockMovesSearchConfig?.find(eachOption => eachOption.name === "warehouseId")
                            if (relatedCustomSearchConfig) {
                                setSearchConfig([...searchConfig, relatedCustomSearchConfig])
                            }
                        }

                        dispatch(updateSearchOptions([...updatedSearchOptions]))
                    }
                }
            }
        }
    }, [searchParams])

    useEffect(() => {
        if (props.companyWarehouses?.length > 0) {
            customStockMovesSearchConfig?.map(eachConfig => {
                if (eachConfig?.name === "warehouseId") {
                    const updatedCompanyBranches = props.companyWarehouses?.map(eachWarehouse => ({ label: eachWarehouse.warehouseName, value: eachWarehouse.warehouseId }))
                    eachConfig.options = updatedCompanyBranches
                    return { ...eachConfig }
                }
                return eachConfig
            })
        }
    }, [props.companyWarehouses])

    const addFilterOption = (srNO) => {
        const relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        // if(relatedConfig.name === "warehouseId"){
        //     const updatedCompanyBranches = props.companyWarehouses?.map(eachWarehouse => ({label:eachWarehouse.warehouseName, value:eachWarehouse.warehouseId}))
        //     relatedConfig.options = updatedCompanyBranches
        // }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = { ...searchParams }

        if (relatedSearchOption.type === "SEARCH_BY") {
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "DATE") {
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            console.log("updateSearchParams", updatedSearchParams)
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "SELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value 
        const updatedSearchParams = { ...searchParams, [event.target.name]: event.target.value }

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        dispatch(updateSearchParams(updatedSearchParams))

        if (event.target.name === 'dataType') {
            dispatch(updateStockSnapshotData([]))
        }

        handleTableColumn(updatedSearchParams)
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const downloadData = async (dataFormat) => {
        let response = []
        if (searchParams?.dataType === "stockDoc") {
            response = await searchStockDoc({ ...searchParams, paginator: false })
        } else {
            response = await searchStockWarehouse({ ...searchParams, paginator: false })
        }
        console.log("stockDocDownload-sheet", response)

        const responseData = response?.data?.data

        let stockDataSheet = []
        

        if (dataFormat === "CSV") {
            let csv = Papa.unparse(responseData, { download: true })
            let blob = new Blob([csv])
            let a = window.document.createElement("a")
            a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
            a.download = searchParams?.dataType === "stockDoc" ? "stockDoc.csv" : "stockWarehouse.csv"
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
        if (dataFormat === "XLSX") {
            const ws = utils.json_to_sheet(responseData)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Sheet1')
            const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = searchParams?.dataType === "stockDoc" ? "stockDoc.xlsx" : "stockWarehouse.xlsx"
            a.click()
            URL.revokeObjectURL(url)
        }
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadData("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadData("CSV")
        }
    ]

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 
    
    const handleSearch = () => {
        if (searchParams.searchBy !== "all") {
            if (searchParams.searchText === "") {
                const errorMsgText = searchParams.searchBy.replace(/(_|-)/g, ' ')
                    .trim()
                    .replace(/\w\S*/g, function (str) {
                        return str.charAt(0).toUpperCase() + str.substr(1)
                    })
                    .replace(/([a-z])([A-Z])/g, '$1 $2')
                    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
                return dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: "Please enter search text", life: 3000 }))
            }
        }
        dispatch(fetchStockSnapshot({ ...paginationParams, ...searchParams, pageNo: 0 }))
    }

    return (
        <div className="p-card" style={{ border: "1px solid #e9ecef" }} onKeyDown={handleSearchKeyPress}>
            <div className="grid">
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_BY") {
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)}></i>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12 compny-serch-by-dropdown">
                                        <DropDownField name="searchBy" labelText="Search By" options={eachOption.options} value={searchParams["searchBy"]} onChange={handleSearchOnChange} />
                                    </div>
                                    {searchParams.searchBy !== "all" ?
                                        <div className="flex flex-column col-12">
                                            <TextInputField name="searchText" labelText="Search Text" value={searchParams["searchText"]} onChange={handleSearchOnChange} />
                                        </div> : null
                                    }
                                </>
                            )
                        }
                        if (eachOption.type === "DATE") {
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name="dateType" labelText="Date Type" options={eachOption.options} value={searchParams["dateType"]} onChange={handleSearchOnChange} />
                                    </div>
                                    {/* <div className="flex flex-column col w-12">
                                        <CalendarField name="fromDate" labelText="From Date" value={searchParams["fromDate"]} onChange={handleSearchOnChange} />
                                    </div>
                                    <div className="flex flex-column col-12 w-12">
                                        <CalendarField name="toDate" labelText="To Date" value={searchParams["toDate"]} onChange={handleSearchOnChange} />
                                    </div> */}
                                    <div className='flex justify-content-between col-12 align-item-center pl-0 pt-0'>
                                        <div className="flex flex-column col-6 pb-0">
                                            <CalendarField name="fromDate" labelText="From Date" value={searchParams["fromDate"]} onChange={handleSearchOnChange} />
                                        </div>
                                        <span className='align-self-center mt-4'>-</span>
                                        <div className="flex flex-column col-6 pb-0">
                                            <CalendarField name="toDate" labelText="To Date" value={searchParams["toDate"]} onChange={handleSearchOnChange} />
                                        </div>
                                    </div>
                                </>
                            )
                        }
                        if (eachOption.type === "SELECT") {
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }
                    })
                }
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}>
                            <Button label="Search" style={{ flexGrow: 1 }} className="py-2" onClick={handleSearch} disabled={isLoading} />
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3" onClick={(e) => downloadMenu.current.toggle(e)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;